import { render, staticRenderFns } from "./SideCategories.vue?vue&type=template&id=718cbefd&scoped=true&"
import script from "./SideCategories.vue?vue&type=script&lang=js&"
export * from "./SideCategories.vue?vue&type=script&lang=js&"
import style0 from "./SideCategories.vue?vue&type=style&index=0&id=718cbefd&scoped=true&lang=css&"
import style1 from "./SideCategories.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718cbefd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
